import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { onCLS, onINP, onLCP } from 'web-vitals';
import { MsalProvider } from '@azure/msal-react';
import App from './App';
import { store, persistor } from './store';
import { GOOGLE_DRIVE_CLIENT_ID, API } from './constants/Constants';
import msalInstance from './services/msalConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <GoogleOAuthProvider clientId={GOOGLE_DRIVE_CLIENT_ID}>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </GoogleOAuthProvider>
    </PersistGate>
  </Provider>,
  // </React.StrictMode>
);

const reportWebVitals = (metric) => {
  const data = JSON.stringify({
    name: metric.name,
    id: metric.id,
    value: metric.value,
    url: window.location.pathname,
  });
  const url = `${API.SEND_METRICS_DATA}`; // Replace with your backend URL

  // Use the Beacon API to send data to your backend
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, data);
  } else {
    fetch(url, {
      data,
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
};

onCLS(reportWebVitals);
onINP(reportWebVitals);
onLCP(reportWebVitals);
